module.exports = __webpack_public_path__ + "static/media/carrefour-logo.dd097e3a.png";